// extracted by css-extract-rspack-plugin
export default {"wrapper":"_319f29","subHeader":"_9be1dcc1","swiperList":"_c6727f2","swiperItem":"_86d890c5"};